import React from 'react';
import cn from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';

import styles from './DescriptionWrapper.module.scss';

export const DescriptionWrapper = ({
  child,
  value,
  textField = true,
}: {
  child: React.ReactElement;
  value?: string;
  textField?: boolean;
}): React.ReactElement => (
  <div className={styles.wrapper}>
    <div className={cn({ [styles.textField]: textField })}>{child}</div>
    {value ? (
      <div className={cn({ [styles.iconTextField]: textField, [styles.iconBooleanField]: !textField })}>
        <Tooltip content={value} hideOnClick={false}>
          <div>
            <Icon name="info" />
          </div>
        </Tooltip>
      </div>
    ) : (
      <div className={styles.emptyBlock}></div>
    )}
  </div>
);
